const AFFILIATE_TAG = "highestefficiencysolarcell-20";

/**
 * Returns an affiliate-tagged Amazon URL only if a valid direct product URL is provided.
 * Returns null if no URL is given or if the URL is a search result page.
 * POLICY: Never generate affiliate links to Amazon search results.
 */
export function getAmazonUrl(url) {
  if (!url) return null;
  // Reject search URLs — only allow direct product pages
  if (url.includes("/s?") || url.includes("gp/search") || url.includes("?k=")) return null;
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set("tag", AFFILIATE_TAG);
    return urlObj.toString();
  } catch {
    return null;
  }
}

/**
 * Build a direct Amazon product URL from an ASIN.
 * Returns null if no ASIN provided.
 */
export function getAmazonUrlFromAsin(asin) {
  if (!asin || asin.length < 8) return null;
  return `https://www.amazon.com/dp/${asin}?tag=${AFFILIATE_TAG}`;
}

/** @deprecated Do not use — creates search result links, not direct product pages */
export function getAmazonSearchUrl(query) {
  // Not used for affiliate CTAs. Kept for reference only.
  return null;
}

export function trackAmazonClick(productName, category) {
  try {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'amazon_click', {
        product_name: productName,
        category: category,
      });
    }
  } catch {}
}

export const AFFILIATE_TAG_ID = AFFILIATE_TAG;

export const AFFILIATE_DISCLOSURE_SHORT = "As an Amazon Associate, we earn from qualifying purchases.";

export const AFFILIATE_DISCLOSURE_FULL = "As an Amazon Associate, we earn from qualifying purchases. This helps support our site at no extra cost to you.";